export default __webpack_public_path__ + "static/natasha-9f57f4d0bceb0ac098c5ad1276c34eda.jpg";